export function publicAssetUrl(path: string): string {
  const normalizedPath = path.replace(/^\.\//, "").replace(/^\//, "");
  const configuredBase = import.meta.env.BASE_URL || "/";
  const runtimeBase =
    typeof window !== "undefined" &&
    window.location.protocol === "file:" &&
    configuredBase === "/"
      ? "./"
      : configuredBase;
  const base = runtimeBase.endsWith("/") ? runtimeBase : `${runtimeBase}/`;
  return `${base}${normalizedPath}`;
}
